module.exports = __webpack_public_path__ + "static/img/pop_bg_login.3f422eb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/pop_bg_login.png
// module id = InEN
// module chunks = 1